export const SET_FILTER = "SET_FILTER";
export const TOGGLE_FILTER = "TOGGLE_FILTER";
export const SET_FILTER_COUNT = "SET_FILTER_COUNT";
